import styled from 'styled-components'

export const AppContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #161616;
`

export const Frame = styled.iframe`
  width: 100%;
  height: 100vh;
  border: 0;
  display: block;
`

export const Message = styled.div`
  padding: 24px;
  color: #ffffff;
`
